import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestResyncSyncTargetUsers (action) {
  const { id, callback } = action.payload

  yield call(apiAction, 'ResyncSyncTargetUsers', {
    id
  })

  callback()
}
